import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const LinkRoute = styled.div`
  padding: 16px;

  ${mediaQuery.desktop`
padding: 10px 40px;
`}
`;

export const Container = styled.div`
  padding: 24px 16px;
  background: #fafafa;
  display: grid;
  grid-template-columns: auto;
  align-items: flex-start;
  gap: 17px;

  .left {
    width: auto;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .right {
    width: 100%;
  }

  ${mediaQuery.desktop` 
  padding: 10px 40px;
  padding-bottom: 90px;
  background: #FAFAFA;
  display: grid;
  grid-template-columns: 850px auto;
  align-items: flex-start;
  gap: 17px;

  .left {
    width: 850px;
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  .right {
    width: 100%;
  }
  `}
`;

export const SummaryBox = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  width: 100%;

  ${mediaQuery.desktop`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  width: auto;
  `}

  .header {
    padding: 18px;
    border-bottom: 1px solid #e0e0e0;
    color: #333333;
    font-size: 18px;
    font-weight: 700;
  }

  .content {
    padding: 18px;
  }

  .body {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  .card {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: flex-start;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 18px;
  }

  img {
    width: 66px;
    height: 86px;
    object-fit: cover;
    border-radius: 1px 1px 0px 1px;
  }

  .text_box {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  h6 {
    color: #333333;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .price {
    color: #333333;
    margin: 0;
    font-size: 14px;
    font-weight: 500;
  }

  .subTotal_box {
    padding: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e0e0e0;

    p {
      margin: 0;
      color: #333333;
      font-size: 16px;
      font-weight: 400;
    }
  }

  .total_box {
    padding: 18px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      margin: 0;
      color: #333333;
      font-size: 16px;
      font-weight: 700;
    }
  }
`;

export const ContentCard = styled.div`
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  background: #fff;
  width: auto;

  .header {
    padding: 18px;
    border-bottom: 1px solid #e0e0e0;
    color: #333333;
    font-size: 18px;
    font-weight: 700;
  }

  .body {
    padding: 18px;
  }

  h5 {
    margin: 0;
    font-size: 14px;
    font-weight: 400;
    color: #828282;
  }

  .title {
    color: #333333;
    font-size: 14px;
    font-weight: 700;
    margin: 0;
  }

  .sub {
    color: #4f4f4f;
    font-size: 14px;
    font-weight: 400;
    margin: 0;
  }
`;
